import { CompanyTypesEnum } from './enumsUtil';

/**
 * Builds grouped Select options from a flat list of operator companies,
 * separating DSP companies from traditional logistics operators.
 * Mirrors the grouping pattern used in AssignOperator (DSP + Operador Tradicional).
 *
 * @param {Array} operators - flat array of company objects, each expected to
 *   carry `companyType`, `isNotIntegred`, `businessName` (or `description`)
 *   and `idCompany`.
 * @returns {Array} grouped options: [{ label, options: [{label, value}] }],
 *   omitting the DSP group entirely when there is no DSP data.
 */
export const buildOperatorGroupedOptions = (operators) => {
  if (!operators || operators.length === 0) return [];

  const groupedOptions = [];

  const dspOperators = operators.filter(
    (e) => e.companyType === CompanyTypesEnum.DSP && e.isNotIntegred === false
  );

  if (dspOperators.length > 0) {
    groupedOptions.push({
      label: 'DSP',
      options: dspOperators.map((e) => ({
        label: e.businessName ?? e.description,
        value: e.idCompany,
      })),
    });
  }

  groupedOptions.push({
    label: 'Operador Tradicional',
    options: operators
      .filter((e) => e.companyType === CompanyTypesEnum.LOGISTICS_OPERATOR && e.isNotIntegred === false)
      .map((e) => ({
        label: e.businessName ?? e.description,
        value: e.idCompany,
      })),
  });

  return groupedOptions;
};
